var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01b6f5",
    d: "M5.4,1.1L4.6,4.9c0,0,0,0.2-0.3,0.2c-0.2,0-0.2,0-0.2,0L2.5,3.8L1.9,3.3L0.8,3c0,0-0.2,0-0.2-0.2 s0.2-0.2,0.2-0.2l4.3-1.7h0.2C5.4,0.9,5.4,0.9,5.4,1.1L5.4,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b6f5",
    d: "M3.2,4.3L2.5,4.9l0,0l0,0l0.2-1.1L3.2,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01b0f5",
    d: "M4.6,1.7C4.6,1.7,4.4,1.7,4.6,1.7L1.9,3.3c0,0,0.5,1.1,0.5,1.4c0,0.2,0.2,0.2,0.2,0.2l0.2-1.1L4.6,1.7 C4.6,1.9,4.6,1.7,4.6,1.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e7c321858fec923f8c013ee53ef3c414.svg";
export { ForwardRef as ReactComponent };